import { createContext, useContext, type ReactNode } from "react"
import { APP_PAGE_KEYS, type AppPageKey } from "./pageAccess"

export type AppPermissions = {
  allowed: boolean
  isAdmin: boolean
  allowedPages: AppPageKey[]
  email?: string
  displayName?: string | null
}

const devPermissions: AppPermissions = {
  allowed: true,
  isAdmin: true,
  allowedPages: [ ...APP_PAGE_KEYS ],
}

const AuthContext = createContext<AppPermissions>(devPermissions)

export const AuthProvider = ({ value, children }: { value: AppPermissions; children: ReactNode }) => (
  <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
)

export const useAuth = () => useContext(AuthContext)

export const useCanAccessPage = (pageKey: string) => {
  const { allowedPages } = useAuth()
  return allowedPages.includes(pageKey as AppPageKey)
}
